import { DebugLogger } from 'lib/debugLogger';
import { IS_BIZ_USER, IS_MOBILE_BROWSER, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { features } from 'reactApp/mail-features';

export const defaultOverquotaMoreInfoUrl = 'https://help.mail.ru/cloud_web/files/overflowing/';

export const overquotaMoreInfoUrl = features.getAsURL('overquota-more-info-url', defaultOverquotaMoreInfoUrl);

export const overquotaCommunicationsClearButton = features.has('overquota-communications-clear-button');

interface OverquotaModalConfig {
    // фича включена?
    enabled: boolean;
    // показывать кнопку очистки
    clearButton: boolean;
}
export const overquotaModalConfig: OverquotaModalConfig = features.getAsJSONWithDefaults('overquota-modal-config', {
    enabled: true,
    clearButton: overquotaCommunicationsClearButton,
} as OverquotaModalConfig);

interface OverquotaModalViewerConfig {
    // показывать кнопку очистки
    clearButton: boolean;
}
export const overquotaModalViewerConfig: OverquotaModalViewerConfig = features.getAsJSONWithDefaults('overquota-modal-viewer-config', {
    clearButton: overquotaCommunicationsClearButton,
} as OverquotaModalViewerConfig);

interface OverquotaDisabledFeaturesModal {
    // показывать кнопку очистки
    clearButton: boolean;
}
export const overquotaDisabledFeaturesModalConfig: OverquotaDisabledFeaturesModal = features.getAsJSONWithDefaults(
    'overquota-disabled-features-modal-config',
    {
        clearButton: overquotaCommunicationsClearButton,
    } as OverquotaDisabledFeaturesModal
);

interface OverquotaFileLoadConfig {
    // показывать кнопку очистки
    clearButton: boolean;
}
export const overquotaFileLoadConfig: OverquotaFileLoadConfig = features.getAsJSONWithDefaults('overquota-file-load-config', {
    clearButton: overquotaCommunicationsClearButton,
} as OverquotaFileLoadConfig);

interface OverquotaBannerConfig {
    // включена ли фича
    enabled: boolean;
    // тип второй кнопки
    secondaryButton: 'clear' | 'help' | 'none';
    // Ссылка на хелп для второй кнопки типа 'help'
    helpLink: string;
}
export const overquotaBannerConfig: OverquotaBannerConfig = features.getAsJSONWithDefaults('overquota-banner-config', {
    enabled: true,
    secondaryButton: 'help',
    helpLink: defaultOverquotaMoreInfoUrl,
} as OverquotaBannerConfig);

interface OverquotaFoldersConfig {
    // включена ли фича
    enabled: boolean;
    // показывать кнопку очистки
    clearButton: boolean;
    // количество папок в плашке
    count: number;
    // url который открывается по клику на папку "Почта"
    url: string;
}
// cloudweb-19905
export const overquotaFoldersConfig: OverquotaFoldersConfig = features.getAsJSONWithDefaults('overquota-folders-config', {
    enabled: false,
    clearButton: overquotaCommunicationsClearButton,
    count: 4,
    url: 'https://e.mail.ru',
} as OverquotaFoldersConfig);

interface OverquotaPaywallConfig {
    // набор тарифов
    // https://onlineconf.mail.ru/#/cloud/services/cloud-web/features/tariff-buy-disable-ads-tariff-ids
    tariffs: number;
    // выбранный тариф (m/y)
    activeTab: string;
    // заголовок окна пейвола
    title: string;
    // заголовок окна покупки конкретного тарифа
    paymentTitle: string;
}

export const overquotaPaywallConfig: OverquotaPaywallConfig = features.getAsJSONWithDefaults('overquota-paywall-config', {
    tariffs: 51,
    activeTab: 'y',
    title: 'Облако без ограничений с подпиской Mail Space',
    paymentTitle: 'Снятие ограничений с подпиской Mail Space',
} as OverquotaPaywallConfig);

export const disableAdsIframeSendHashAnalytics = features.has('disable-ads-iframe-send-hash-analytics');

export const buyDisableAdsDebug = features.has('buy-disable-ads-debug');

export const disableAdsLogger = new DebugLogger({ DEBUG_SCOPE: 'DisableAds', DEBUG: buyDisableAdsDebug });

// куда отправлять по кнопке покупки в коммуникациях
const payPlacements = ['paywall', 'landing'] as const;
export const overquotaCommunicationPayPlacement = features.getAsEnum('overquota-communication-pay-placement', payPlacements, 'paywall');

const defaultHiddenConfig = {
    trialOnboarding: false,
    trial1tbBannerPromo: false,

    disableAdButton: {
        mainPage: false,
        public: false,
        viewer: false,
        worm: false,
    },
};

// Фича для выключения для оверквотеров различных частей Облака
export const hideOverquotaFeatures: typeof defaultHiddenConfig = features.getAsJSON('cloud-hide-overquota-features', defaultHiddenConfig);

export const blockOverquotaViewer = !IS_PAID_USER && !IS_BIZ_USER && !IS_MOBILE_BROWSER && features.has('block-overquota-viewer');
